import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 3,
    class: "my-1 h-px w-full border-0 bg-(--colors-border-base-soft)"
};
import { Button, Dropdown, DropdownItemButton } from "@eudonet/opal";
// Each entry follows its own server flag (R42): hidden, never disabled, when the flag is false.
export default /*@__PURE__*/ _defineComponent({
    __name: 'AdvancedFilterRowMenu',
    props: {
        canEdit: { type: Boolean },
        canDelete: { type: Boolean },
        canManageAccess: { type: Boolean }
    },
    emits: ["edit", "rename", "delete", "manage-access"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Dropdown), {
                "menu-align": "right",
                "menu-width": "208px"
            }, {
                trigger: _withCtx(({ triggerProps }) => [
                    _createVNode(_unref(Button), _mergeProps(triggerProps, {
                        variant: "ghost",
                        size: "xs",
                        "icon-only": "",
                        "icon-left": "ri-more-line",
                        "aria-label": _ctx.$t('advancedFilterLibrary.menu.ariaLabel'),
                        "data-testid": "filter-row-menu-trigger",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"])),
                        onKeydown: [
                            _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => { }, ["stop"]), ["enter"])),
                            _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => { }, ["stop"]), ["space"]))
                        ]
                    }), null, 16 /* FULL_PROPS */, ["aria-label"])
                ]),
                menu: _withCtx(() => [
                    (props.canManageAccess)
                        ? (_openBlock(), _createBlock(_unref(DropdownItemButton), {
                            key: 0,
                            item: {
                                label: _ctx.$t('advancedFilterLibrary.menu.manageAccess'),
                                icon: 'ri-file-transfer-line',
                                testId: 'filter-row-menu-manage-access',
                            },
                            onClick: _cache[3] || (_cache[3] = ($event) => (emit('manage-access')))
                        }, null, 8 /* PROPS */, ["item"]))
                        : _createCommentVNode("v-if", true),
                    (props.canEdit)
                        ? (_openBlock(), _createBlock(_unref(DropdownItemButton), {
                            key: 1,
                            item: {
                                label: _ctx.$t('advancedFilterLibrary.menu.edit'),
                                icon: 'ri-pencil-fill',
                                testId: 'filter-row-menu-edit',
                            },
                            onClick: _cache[4] || (_cache[4] = ($event) => (emit('edit')))
                        }, null, 8 /* PROPS */, ["item"]))
                        : _createCommentVNode("v-if", true),
                    (props.canEdit)
                        ? (_openBlock(), _createBlock(_unref(DropdownItemButton), {
                            key: 2,
                            item: {
                                label: _ctx.$t('advancedFilterLibrary.menu.rename'),
                                icon: 'ri-pencil-line',
                                testId: 'filter-row-menu-rename',
                            },
                            onClick: _cache[5] || (_cache[5] = ($event) => (emit('rename')))
                        }, null, 8 /* PROPS */, ["item"]))
                        : _createCommentVNode("v-if", true),
                    (props.canDelete && (props.canManageAccess || props.canEdit))
                        ? (_openBlock(), _createElementBlock("hr", _hoisted_1))
                        : _createCommentVNode("v-if", true),
                    (props.canDelete)
                        ? (_openBlock(), _createBlock(_unref(DropdownItemButton), {
                            key: 4,
                            item: {
                                label: _ctx.$t('advancedFilterLibrary.menu.delete'),
                                icon: 'ri-delete-bin-line',
                                danger: true,
                                testId: 'filter-row-menu-delete',
                            },
                            onClick: _cache[6] || (_cache[6] = ($event) => (emit('delete')))
                        }, null, 8 /* PROPS */, ["item"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
